import { ApiResponse, apiCall } from "./apiClient";
import { TransportTask } from "../models/transport/transportTask";

export const getTransportTasks = (transportOrderId: string): Promise<ApiResponse<TransportTask[]>> => {
    return apiCall<TransportTask[]>(`transportTasks/transportOrder/${transportOrderId}`, "GET");
};
